import React from "react";

import Misc from './../../misc/misc';
import {getMousePos, requestAnimFrame, isTouchDevice} from "../../misc/utils";
import {isIE} from "../../misc/helpers";
import {loaderDisable} from "../ui/loaderView";
import enhanceCanvas from "./canvasEnhancements";
// import {UseFullSizeImages} from "../../config";
import {getBackgroundLayers} from "../../misc/getCanvasImageFromLayout";
import ImageCanvasCommon from "./imageCanvasCommon";

// import { getHoverZonesForPreset, getHoveringZone, hoverImages } from "./imageCanvasTouchZones";

export default class ImageCanvasCommonNew extends ImageCanvasCommon {

  setMouseHoverFunction() {
    if (!this.props.useMouseHovering || this.state.mouseMoveSet || !this.canvas) {
      return
    }
    const isMobile = Misc.isMobile() || isTouchDevice();
    if (!isMobile && !isIE()) {
      this.setOnMouseMove();
    }
  }

  finishDraw = (images, layers, alreadyRenderedImages, errorImages, callback) => {
    clearTimeout(this.id);
    this.id = 0;
    let copyImages = null;

    const {width, height} = this.props;

    // const fullImagesFactor = UseFullSizeImages ? 100 : 54;

    if (this.props.useMouseHovering && (this.shouldUpdateGreenZone || !this.state.layersHoverings.length)) {
      copyImages = [...images];
    }

    const backgroundLayers = getBackgroundLayers(layers, null, true);

    // console.log("layers", layers);

    if (backgroundLayers.length) { // draw backgrounds first
      this.backCtxBg.clearRect(0, 0, width, height); // clear previous

      images.forEach((imageObject) => {
        if (imageObject.src.includes("data:image") || errorImages.includes(imageObject.src)) {
          return
        }
        const layer = backgroundLayers.find(layer => layer.image === imageObject.src);
        if (layer) {
          this.drawImage(layer, imageObject, this.backCtxBg, width, height)
        }
        imageObject = null;
      });
      enhanceCanvas(this.canvasBg);
      this.backCtx.drawImage(this.canvasBg, 0, 0, width, height, 0, 0, width, height);
      const greenImage = images.find((imageObject) => imageObject.src.includes("data:image"));
      if (greenImage) {
        const layer = backgroundLayers.find(layer => layer.image === greenImage.src);
        if (layer) {
          this.drawImage(layer, greenImage, this.backCtx, width, height)
        }
      }
    }

    images.forEach((loadedImage) => {
      if (errorImages.includes(loadedImage.src)) {
        return
      }
      const layer = layers.find(layers => layers.image === loadedImage.src);
      if (layer && (!backgroundLayers.length || (layer.zIndex < backgroundLayers[backgroundLayers.length - 1].zIndex))) {
        this.drawImage(layer, loadedImage, this.backCtx, width, height)
      }
      loadedImage = null;
    });

    // this.ctx.drawImage(this.backCtx.canvas, 0, 0);
    requestAnimFrame(this.ctx.drawImage(this.backCtx.canvas, 0, 0));

    this.setMouseHoverFunction();

    if (this.props.useMouseHovering) {
      this.setState({
        alreadyRenderedImages
      });
      if (this.shouldUpdateGreenZone || !this.state.layersHoverings.length) {
        this.setLayersHoverings(layers, copyImages, errorImages)
      }
    }

    if (!window.requestInProcess) {
      if (this.props.setShowCanvasLoader) {
        this.props.setShowCanvasLoader(false)
      } else {
        this.props.disableLoader ? this.props.disableLoader() : loaderDisable();
      }
    }

    // window.t1 = performance.now();
    // console.log("Call to doSomething took " + (window.t1 - window.t0) + " milliseconds.");

    if (callback) {
      callback()
    }
  };

  getGliaImage = () => {
    return (
      <div className="canvas-co">
        <img ref={(el) => this.canvasImg = el} alt="" id={this.props.canvasId + "Img"}
             className="canvas-co-image blurred" />
      </div>
    )
  };

  nonTransparentPixelHovered = (mousePosArray, layerHovering) => {
    if (!this.state.dimensions.width || !this.state.dimensions.height) {
      return false; // we can't divide by 0
    }
    const x1 = layerHovering.layer.cropCoords ? layerHovering.layer.cropCoords[0] : layerHovering.layerDimensions.polygonArray[0][0];
    const y1 = layerHovering.layer.cropCoords ? layerHovering.layer.cropCoords[1] : layerHovering.layerDimensions.polygonArray[0][1];
    return mousePosArray.some(mousePos => {
      let pixelHovered = null;
      // hoveredPixelCoords (base class) is resize/zoom-safe under USE_NEW_CANVAS.
      const c = this.hoveredPixelCoords(mousePos, x1, y1);
      try {
        pixelHovered = layerHovering.context2D.getImageData(c.x, c.y, 1, 1, {willReadFrequently: true}).data[3]
      } catch (e) {
        console.log("can't find hovered pixel", layerHovering.context2D, c.x, c.y);
      }
      return pixelHovered > 120
    })
  }

  setHoveredLayer = (evt) => {

    if (window.touchMove || !this.props.useMouseHovering) {
      return false
    }

    // Keep hovering (green-zone highlighting) working while zoomed. The scale is
    // read here and factored into the hit-test in nonTransparentPixelHovered, so
    // we no longer bail out when canvas_scale !== 1.
    if (this.pinchZoom) {
      this.canvas_scale = this.pinchZoom.getScale();
    }

    const {layout} = this.props;
    const canvas = this.canvas;
    let mousePos = getMousePos(evt, canvas);
    let hovered = false;

    // console.log('mousePos', mousePos);

    if (mousePos && (window.innerWidth < 480)) { // rotated version
      let temp = mousePos.x;
      // noinspection JSSuspiciousNameCombination
      mousePos.x = mousePos.y;
      mousePos.y = this.canvas.offsetHeight - temp;
      // console.log('mousePos2', mousePos);
    }

    if (this.state.layersHoverings.length) {
      let i = 0;
      for (i; i < this.state.layersHoverings.length; i++) {
        const layerHovering = this.state.layersHoverings[i];
        if ( mousePos
          && layerHovering
          && layerHovering.layerDimensions
          && !this.layerIsExcludedFromHover(layerHovering.layer, layout)
          // && pnpoly(layerHovering.layerDimensions.polygonArray, mousePos)
        ) {
          let mousePosArray = [mousePos];
          if (layout.checkMorePointsPartIds && layout.checkMorePointsPartIds.includes(layerHovering.layer.partId)) {
            for (let k = 1; k <= 20; k++) {
              mousePosArray = [
                ...mousePosArray,
                {x: mousePos.x - k, y: mousePos.y - k},
                {x: mousePos.x + k, y: mousePos.y - k},
                {x: mousePos.x - k, y: mousePos.y + k},
                {x: mousePos.x + k, y: mousePos.y + k},
                {x: mousePos.x - k, y: mousePos.y},
                {x: mousePos.x + k, y: mousePos.y},
                {x: mousePos.x, y: mousePos.y - k},
                {x: mousePos.x, y: mousePos.y + k},
              ]
            }
          }
          // console.log("checkMorePointsPartIds", mousePosArray);
          if (this.nonTransparentPixelHovered(mousePosArray, layerHovering)) {
            hovered = true;
            if (this.canvas) {
              this.canvas.style.cursor = "pointer"; // hovering a clickable layer
            }
            document.hoveredLayer = layerHovering.layer;
            document.hoveredMousePos = mousePos;
            if (!isIE() && (this.activeGreenZoneIndex !== layerHovering.layer.zIndex)) {
              // console.log('layerHovering active = ', layerHovering);
              this.activeGreenZoneIndex = layerHovering.layer.zIndex;
              this.renderGreenLayer(layerHovering);
            }

            break;  // break for...of loop
          }
        }
      }
    }

    if (!hovered) {
      if (this.canvas && !this.isDragging) {
        this.canvas.style.cursor = ""; // nothing clickable under the cursor
      }
      document.hoveredLayer = null;
      this.draw(this.state.layers);   // reload all layers without hovered
    }

  };

  renderGreenLayerByZindex = (zIndex, partId) => {
    if (!isIE()) {
      const neededLayerHovering = this.state.layersHoverings.find((layerHovering) => {
        if (partId) {
          return layerHovering.layer.zIndex === zIndex && layerHovering.layer.partId === partId
        }
        return layerHovering.layer.zIndex === zIndex
      });
      neededLayerHovering ? this.renderGreenLayer(neededLayerHovering, true) : this.draw(this.state.layers)
    }
  };

  drawImage = (layer, imageObject, canvasContext, width, height) => {
    try {
      if (layer.cropCoords) {
        let layerWidth = layer.cropCoords[2] - layer.cropCoords[0];
        let layerHeight = layer.cropCoords[3] - layer.cropCoords[1];
        canvasContext.drawImage(imageObject, 0, 0, layerWidth, layerHeight, layer.cropCoords[0], layer.cropCoords[1], layerWidth, layerHeight);
      } else if (layer.layerDimensions) {
        const dim = layer.layerDimensions;
        // console.log('yep', dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        const firstX = layer.isGreenHovering ? 0 : dim.polygonArray[0][0]; // green is already cropped
        const firstY = layer.isGreenHovering ? 0 : dim.polygonArray[0][1]; // green is already cropped
        canvasContext.drawImage(imageObject, firstX, firstY, dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        // } else if (loadedImage.coords) {
        // loadedImage.width = loadedImage.width*fullImagesFactor/100;
        // loadedImage.height = loadedImage.height*fullImagesFactor/100;
        // const max_x = loadedImage.coords.max_x*fullImagesFactor/100;
        // const min_x = this.props.width*loadedImage.coords.min_x;
        // const min_y = this.props.height*loadedImage.coords.min_y;
        // const max_y = loadedImage.coords.max_y*fullImagesFactor/100;
        // const width = max_x - min_x;
        // const height = max_y - min_y;
        // console.log('width', width);
        // console.log('height', height);
        // console.log('min_x', min_x);
        // console.log('min_y', min_y);
        // console.log('max_x', max_x);
        // console.log('max_y', max_y);
        // this.backCtx.drawImage(loadedImage, 0, 0, loadedImage.width, loadedImage.height, min_x, min_y, loadedImage.width, loadedImage.height);
      } else {
        // imageObject.width = width;
        // imageObject.height = height;
        canvasContext.drawImage(imageObject, 0, 0, width, height);
      }
    } catch (e) {
      console.log("canvas context cant draw image", imageObject);
    }
  }

  onMouseDown = (event) => {
    if (this.pinchZoom && this.pinchZoom.onMouseDown) {
      this.pinchZoom.onMouseDown(event)
    }
  }

  onMouseMove = (event) => {
    if (this.pinchZoom && this.pinchZoom.onMouseMove) {
      this.pinchZoom.onMouseMove(event)
    }
  }

  onMouseUp = (event) => {
    if (this.pinchZoom && this.pinchZoom.onMouseUp) {
      this.pinchZoom.onMouseUp(event, this.props.lookCanvasClick) // we should be here always // callback is passed to execute after drag n drop
    } else if (this.props.lookCanvasClick) {
      this.props.lookCanvasClick()
    }
  }

  render() {
    const style = {};
    if (this.props.transform) {
      style.transform = this.props.transform
    }
    return (
      // <div className="canvas" style={{position: "static"}}>
      <div className="canvas">
        {/*<div className="canvas-text">*/}
        {/*  {this.pinchZoom ? this.pinchZoom.el.style.transform + " // " + this.pinchZoom.container.style.transform : null}*/}
        {/*</div>*/}
        {this.props.useMouseHovering ? this.getGliaImage() : null}
        <canvas ref={(el) => this.canvas = el}
                className={"canvas-el" + (this.props.useMouseHovering ? " canvas-el--pointer" : "")}
                onMouseDown={this.onMouseDown}
                onMouseMove={this.onMouseMove}
                onMouseUp={this.onMouseUp}
                onDoubleClick={null}
                id={this.props.canvasId}
                width={this.props.width}
                height={this.props.height}
          // onTouchStart={this.moveStart}
          // onTouchMove={this.move}
          // onTouchEnd={this.moveEnd}
                data-mobile={Misc.isMobile() || isTouchDevice()}
                style={style} />
      </div>
    );
  }

}
